// src/hooks/useAutoLoadMore.js
//
// Derulare automată în loc de „Afișează încă”: când lista (elementul care se derulează,
// `ref`) ajunge aproape de capăt — jos, sau în dreapta dacă se derulează orizontal — ori
// nu e încă plină, cere următorii (`loadMore`). Verifică la derulare (`onScroll`), după
// fiecare randare și când lista își schimbă mărimea (devine vizibilă, fereastra se
// lărgește). Cât lista e ascunsă (display: none), nu cere nimic. Verificările pot veni de
// mai multe ori până se randează lista nouă: `loadMore` trebuie să ceară o țintă fixă
// (cei randați + încă o pagină), nu „încă o pagină” la fiecare apel.
import { useCallback, useEffect, useRef } from "react";

// cât înainte de capăt vin următorii
const EDGE = 160;

export default function useAutoLoadMore(canLoadMore, loadMore) {
   const ref = useRef(null);

   const check = useCallback(() => {
      const el = ref.current;
      if (!el || !canLoadMore || !el.getClientRects().length) return;
      // ambele: lista verticală e mereu „la capăt” pe orizontală, rândul orizontal pe verticală
      const nearBottom = el.scrollTop + el.clientHeight > el.scrollHeight - EDGE;
      const nearRight = el.scrollLeft + el.clientWidth > el.scrollWidth - EDGE;
      if (nearBottom && nearRight) loadMore();
   }, [canLoadMore, loadMore]);

   const checkRef = useRef(check);
   useEffect(() => {
      checkRef.current = check;
      check();
   });

   useEffect(() => {
      const el = ref.current;
      if (!el || typeof ResizeObserver === "undefined") return undefined;
      const ro = new ResizeObserver(() => checkRef.current());
      ro.observe(el);
      return () => ro.disconnect();
   }, []);

   return { ref, onScroll: check };
}
